
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Repeater from "@/components/Reusable/CustomInputs/Repeater/Repeater.vue";
import DropdownInput from "@/components/Reusable/CustomInputs/DropdownInput.vue";
import {
  OEmbedProvider,
  OEmbedProviderV,
  VideoOptions
} from "@/types/controls";

const DEFAULT_VIDEO_OPTIONS = {
  providers: []
};

@Component({
  components: { DropdownInput, Repeater }
})
export default class ElementStudioVideoOptions extends Vue {
  @Prop()
  value!: VideoOptions | null;

  get types() {
    return OEmbedProviderV.types.map(type => type.value);
  }

  get internalValue() {
    return this.value || DEFAULT_VIDEO_OPTIONS;
  }

  updateProviders(providers: OEmbedProvider[] | undefined) {
    this.emit({
      ...this.internalValue,
      providers
    });
  }

  emit(options: VideoOptions) {
    this.$emit("input", options);
  }
}
